import { RouteLocation, RouteRecordRaw } from 'vue-router'
import MeasureValuesChildRoutes from '@/router/measure-values'
import pointParamAssessmentRoutes from '@/router/point-param-assessments'

const routes: Array<RouteRecordRaw> = [
  {
    path: 'bro-delivery',
    name: 'measure-point.bro-delivery',
    meta: { applicationAdminOnly: true },
    component: () => import('@/views/control-panel/projects/project/sections/section/measure-locations/measure-location/measure-points/measure-point/BroDelivery.vue'),
  },
  {
    path: 'edit',
    name: 'measure-point.edit',
    component: () => import('@/views/control-panel/projects/project/sections/section/measure-locations/measure-location/measure-points/measure-point/Edit.vue'),
  },
  {
    path: 'imports',
    name: 'measure-point.imports',
    component: () => import('@/views/control-panel/projects/project/sections/section/measure-locations/measure-location/measure-points/measure-point/Imports.vue'),
    redirect: (to: RouteLocation) => ({ name: 'measure-point.imports.list', params: to.params }),
    children: [
      {
        path: 'list',
        name: 'measure-point.imports.list',
        component: () => import('@/views/control-panel/projects/project/sections/section/measure-locations/measure-location/measure-points/measure-point/imports/List.vue'),
      },
      {
        path: 'new',
        name: 'measure-point.import.create',
        component: () => import('@/views/control-panel/projects/project/sections/section/measure-locations/measure-location/measure-points/measure-point/imports/Create.vue'),
      },
    ]
  },
  {
    path: 'measure-values',
    name: 'measure-values',
    component: () => import('@/views/control-panel/projects/project/sections/section/measure-locations/measure-location/measure-points/measure-point/MeasureValues.vue'),
    // redirect: (to: RouteLocation) => ({ name: 'measure-points.map', params: to.params }),
    children: MeasureValuesChildRoutes
  },
  {
    path: 'information',
    name: 'measure-point.information',
    component: () => import('@/views/control-panel/projects/project/sections/section/measure-locations/measure-location/measure-points/measure-point/Information.vue'),
    redirect: (to: RouteLocation) => ({ name: 'measure-point-information.information', params: { ...to.params } }),
    children: [
      {
        path: 'information',
        name: 'measure-point-information.information',
        component: () => import('@/views/control-panel/projects/project/sections/section/measure-locations/measure-location/measure-points/measure-point/information/Information.vue'),
      },
      {
        path: 'new',
        name: 'measure-point-information.create',
        component: () => import('@/views/control-panel/projects/project/sections/section/measure-locations/measure-location/measure-points/measure-point/information/Create.vue'),
      },
    ]
  },
  {
    path: 'logbook',
    name: 'measure-point.logbook',
    component: () => import('@/views/control-panel/projects/project/sections/section/measure-locations/measure-location/measure-points/measure-point/Logbook.vue'),
  },
  {
    path: 'process',
    name: 'measure-point.process',
    component: () => import('@/views/control-panel/projects/project/sections/section/measure-locations/measure-location/measure-points/measure-point/Process.vue'),
  },
  {
    path: 'param-assessments',
    name: 'point.warning-values',
    component: () => import('@/views/control-panel/projects/project/sections/section/measure-locations/measure-location/measure-points/measure-point/WarningValues.vue'),
    redirect: () => ({ name: 'point.warning-values.list' }),
    children: pointParamAssessmentRoutes
  },
  {
    path: 'form',
    name: 'point.form',
    redirect: (to) => ({ name: 'point.form.single', params: to.params }),
    component: () => import('@/views/control-panel/projects/project/sections/section/measure-locations/measure-location/measure-points/measure-point/Form.vue'),
    children: [
      {
        path: ':formName',
        name: 'point.form.single',
        component: () => import('@/views/control-panel/projects/project/sections/section/measure-locations/measure-location/measure-points/measure-point/form/Single.vue'),
      }
    ]
  }
]

export default routes
